export default __webpack_public_path__ + "static/media/sticker-on.68d035b1.png";